// extracted by mini-css-extract-plugin
export default {"ellipsisAnimated":"EllipsisAnimated-module__ellipsisAnimated--rXQ1J","ellipis-animation":"EllipsisAnimated-module__ellipis-animation--NuXq3"};